import React, { useCallback, useEffect, useRef, useState } from "react";
import { Link, useNavigate, useLocation } from "react-router-dom";
import "./Quickview.scss";
import "react-datepicker/dist/react-datepicker.css";
import { _Api, graphqlPost } from "../common/api/_call";
import CheckoutBlank from "../checkout/checkoutBlank";
import CheckoutSell from "pos/checkout/checkoutSell";
import CheckoutPayment from "pos/checkout/checkoutPayment";
import { success, error, loading, Updateloading } from "../common/helpers/toastify";
import { useSelector } from "react-redux";
import { SetdataTable } from "../common/api/setdatatable";
import { poscustomerwishlist_head } from "../../components/common/Tablehead";
import { Tablehead } from "../../components/common/modules/Tablehead";
import { useTranslation } from "react-i18next";
import NoOrdersYet from "../common/module/NoOrdersYet/NoOrdersYet";
import OrderModal from "./OrderModal";
import ImageGallery from "react-image-gallery";
import quickviewplaceholder from "../../assets/images/quickviewplaceholder.png";
import catalogtogglebtn from "../../assets/images/togglecatlogbtn.png";
import locquickview from "../../assets/images/locquickview.png";
import tracebigimg from "../../assets/images/trace_diamond_big.png"
import OrderTracebilityModal from "./OrderTracebilityModal";
import traceimg from "../../assets/images/TraceItem_diamond.svg";
import faromainicon from "../../assets/images/faromainicon.svg";

import { setIn } from "formik";

const Quickview = () => {
  const { t } = useTranslation();
  const base_assets = process.env.REACT_APP_BASE_ASSETS_URL;
  const posOrgSettings = useSelector((state) => state.app.posorganisation_settings);
  const generalsettings = useSelector((state) => state.app.generalsettings);
  const traceabilityEnabled = generalsettings?.data?.generalsetup?.traceability === "1";
  const isFaroActive = posOrgSettings?.faro_active === 1;
  const handleFaroClick = (e) => {
    if (!isFaroActive) {
      e.preventDefault();
      error(t("Please activate Claude and Voyage both in Settings > Integrated Applications"));
    }
  };
  const [searchlist, setSearchlist] = useState();
  const [isCrown, setCrown] = useState(true);
  const { state } = useLocation();
  const [searchsku, setSearchsku] = useState();
  const [metallist, setMetallist] = useState([]);
  const [stonelist, setStonelist] = useState([]);
  const [sizelist, setSizelist] = useState([]);
  const [metalListCrown, setMetalListCrown] = useState([]);
  const [stoneListCrown, setStoneListCrown] = useState([]);
  const [sizeListCrown, setSizeListCrown] = useState([]);
  const [resultlist, setResultlist] = useState("");
  const [inventoryList, setInventoryList] = useState([]);
  const [show, setShow] = useState(false);
  const [selected, setSelected] = useState(null);
  const [, setQty] = useState();
  const [, setStatus] = useState(false);
  const [po_id, setPo_id] = useState();
  const [imageid, setImageid] = useState();
  const [image, setImage] = useState();
  const [placeholder, setPlaceholder] = useState(true);
  const [productdetails, setProductDetails] = useState();
  const [Customerlist, setCustomerlist] = useState();
  const [wishlistdetails, setWishlistdetails] = useState();
  const [showcheckout, setShowcheckout] = useState("blank");
  const [, setdeletestatus] = useState(false);
  const [showpayment, setShowpayment] = useState(false);
  const [UpdatedCart, setUpdatedCart] = useState();
  const [inv_orderid, setInv_orderid] = useState();
  const [inv_ordertype, setInv_ordertype] = useState();
  const [by_repair_order, setBy_repair_order] = useState();
  const [by_customorder, setBy_customorder] = useState();
  const [cartstockid, setCartstockid] = useState();
  const [uuid, setUuid] = useState("");
  const [searchproductstatus, setsearchproductstatus] = useState(false);
  const saleperson = useSelector((state) => state.app.saleperson);
  const customer = useSelector((state) => state.app.customer);
  const navigate = useNavigate();
  const [stockid, setStockid] = useState("");
  const [parentid, setParentid] = useState("");
  const [reserve, setReserve] = useState(false);
  const [orderCatalogItems, setOrderCatalogItems] = useState([]);
  const pos_loc = localStorage.getItem("pos-loc");
  const parsedObject = JSON.parse(pos_loc);
  const selectLocationflag = parsedObject["loc"] === selected;
  const [crosslocation, setCrosslocation] = useState(false);
  const [crossLocationId, setCrossLocationId] = useState(null);
  // const orderItems = [
  //   { name: "PRIN-R8", code: "10214", quantity: 1, price: "$ 50,000.00" },
  //   { name: "PRIN-R9", code: "10215", quantity: 2, price: "$ 75,000.00" },
  //   { name: "PRIN-R10", code: "10216", quantity: 5, price: "$ 200,000.00" },
  // ];
  const [orderItems, setOrderItems] = useState([]);
  const skipInventoryFilterEffectRef = useRef(false);
  const searchDebounceRef = useRef(null);


  const generateUuid = () => {
    const newUuid = crypto.randomUUID();
    setUuid(newUuid);
  };
  const getsearchproductlist = async (value) => {
    try {
      value = value ? value.trim() : "";
      if (!value) {
        setSearchlist([]);
        return;
      }
      const posdata = {
        search: value,
        type: "catalog",
      };
      let res = await _Api(posdata, `api/v1/Inventory/quickview/search`);
      if (res.code === 200) {
        setSearchlist(res?.data);
      } else {
        setSearchlist([]);
      }
    } catch (err) {
      console.log(err, "err");
    }
  };
  const getsearchproductlistloc = async (loc_id,parentid1, overrides = {}) => {
    try {
      const posdata = {
        location_id: loc_id,
        metal: overrides.metal ?? metallist,
        size: overrides.size ?? sizelist,
        stone: overrides.stone ?? stonelist,
        parentproduct_id: parentid1?parentid1:parentid,
      };
      let res = await _Api(posdata, `api/v1/POS/home/inventoryList`);
      if (res.success === true) {
        setOrderItems(res?.data);
      } else {
      }
    } catch (err) {
      console.log(err, "err");
    }
  };

  const getsearchproductlistloc_crown = async (overrides = {}) => {
    try {
      const posdata = {
        metal: overrides.metal ?? metalListCrown,
        size: overrides.size ?? sizeListCrown,
        stone: overrides.stone ?? stoneListCrown,
        parentproduct_id: overrides.parentproduct_id ?? parentid,
      };
      let res = await _Api(posdata, `api/v1/POS/home/catalogs-items-filter`);
      if (res.success === true) {
        setOrderCatalogItems(res?.data);
      }
    } catch (err) {
      console.log(err, "err");
    }
  };
  const GetCartdetailpark = async () => {
    try {
      const postdata = {
        park_id: state?.parkid,
        order_id: state?.order_id,
        order_edit: state?.order_edit,
        order_type: state?.order_type,
      };
      let res = await _Api(postdata, `api/v1/POS/customOrder/getCartItems`);
      if (res.code === 200) {
        setUpdatedCart(res?.data);
        setsearchproductstatus(true);
        setShowcheckout("sell");
      } else {
        navigate("/app/pos/catalog/CollectionList");
      }
    } catch (err) {
      console.log(err, "err");
    }
  };
  const isCatalogCategorySelected = (option, selectedIds) => {
    if (selectedIds.length > 0) {
      return selectedIds.includes(option?.id);
    }
    return option?.select === 1 && option?.exsits === 1;
  };

  const getCatalogFilterInputClass = (option, selectedIds, forceDisable = false) => {
    if (forceDisable) {
      return "active readonly-input";
    }
    if (option?.select === 0) {
      return "disable-input";
    }
    if (isCatalogCategorySelected(option, selectedIds)) {
      return "active";
    }
    if (option?.exsits === 0) {
      return "border";
    }
    return "";
  };

  const getInventoryFilterInputClass = (option, forceDisable = false) => {
    if (forceDisable) {
      return "active readonly-input";
    }
    if (option?.exsits === 1) {
      return "active";
    }
    if (option?.select === 0) {
      return "disable-input";
    }
    if (option?.exsits === 0) {
      return "border";
    }
    return "";
  };

  const callsearchdetails = async (searchkey, options = {}) => {
    const catalogMode = options.forceCatalog ?? isCrown;
    setPlaceholder(true);
    try {
      const postdata = catalogMode
        ? {
            search: searchkey ? searchkey : searchsku,
            metal: options.metal ?? metalListCrown,
            size: options.size ?? sizeListCrown,
            stone: options.stone ?? stoneListCrown,
          }
        : {
            search: searchkey ? searchkey : searchsku,
            metal: options.metal ?? metallist,
            size: options.size ?? sizelist,
            stone: options.stone ?? stonelist,
          };
      const endpoint = catalogMode
        ? `api/v1/Inventory/quickview/result-catalog`
        : `api/v1/Inventory/quickview/result`;
      let resSearchdata = await _Api(postdata, endpoint);
      if (resSearchdata.code === 200) {
        const productList = resSearchdata?.productList;
        setQty(productList?.total_qty);
        setImageid(productList?.main_id);
        setParentid(productList?.main_id);

        if (catalogMode) {
          setResultlist(productList);
          setSelected(true);

          if (options.syncCatalogSelectionFromApi) {
            setMetalListCrown([]);
            setStoneListCrown([]);
            setSizeListCrown([]);

            if (productList?.main_id) {
              getsearchproductlistloc_crown({
                metal: [],
                size: [],
                stone: [],
                parentproduct_id: productList.main_id,
              });
            } else {
              setOrderCatalogItems([]);
            }
          } else if (
            (postdata.metal?.length ||
              postdata.stone?.length ||
              postdata.size?.length) &&
            productList?.main_id
          ) {
            getsearchproductlistloc_crown({
              metal: postdata.metal,
              size: postdata.size,
              stone: postdata.stone,
              parentproduct_id: productList.main_id,
            });
          } else {
            setOrderCatalogItems([]);
          }
        } else {
          setResultlist(productList);
          setInventoryList(productList);
          getsearchproductlistloc(parsedObject["loc"], productList?.main_id, {
            metal: postdata.metal,
            size: postdata.size,
            stone: postdata.stone,
          });
          setSelected(true);
        }
        setPlaceholder(false);
      }
    } catch (err) {
      console.log(err, "err");
    }
  };

  const updateCatalogFilter = (label, id, option) => {
    if (resultlist?.nonVariant || option?.select === 0) {
      return;
    }

    const toggleId = (list) =>
      list.includes(id) ? list.filter((item) => item !== id) : [...list, id];

    let nextMetal = metalListCrown;
    let nextStone = stoneListCrown;
    let nextSize = sizeListCrown;

    if (label === "metal") {
      nextMetal = toggleId(metalListCrown);
      setMetalListCrown(nextMetal);
    } else if (label === "stone") {
      nextStone = toggleId(stoneListCrown);
      setStoneListCrown(nextStone);
    } else if (label === "size") {
      nextSize = toggleId(sizeListCrown);
      setSizeListCrown(nextSize);
    }

    if (searchsku) {
      callsearchdetails(undefined, {
        forceCatalog: true,
        metal: nextMetal,
        stone: nextStone,
        size: nextSize,
      });
    }
  };

  const update_filters = (label, id, option) => {
    if (isCrown) {
      updateCatalogFilter(label, id, option);
      return;
    }
    if (isCrown === false) {
      if (resultlist?.nonVariant) {
        return;
      }
      if (label === "metal") {
        let metal = [...metallist];
        setSizelist([]);
        setStonelist([]);
        let elem = document.getElementById(id);
        if (elem.classList.contains("active")) {
          resultlist?.metal.forEach((result) => {
            if (result?.select) {
              if (result?.id === id) {
                if (metallist?.length) {
                  elem.classList.add("deactive");
                  let updatemetal = metallist.filter(
                    (item) => item !== result?.id
                  );
                  metal = updatemetal;
                } else {
                  elem.classList.add("active");
                  metal.push(result?.id);
                }
              }
            }
          });
        } else {
          resultlist?.metal.forEach((result) => {
            if (result?.id === id) {
              elem.classList.add("active");
              metal.push(result?.id);
            }
            // else if (result?.id !== id) {
            //   if (result?.select) {
            //     metal.push(result?.id)
            //   }
            // }
          });
        }
        setMetallist(metal);
      }
      if (label === "stone") {
        setSizelist([]);
        let stone = [...stonelist];
        let elem = document.getElementById(id);
        if (elem.classList.contains("active")) {
          resultlist?.Stone.forEach((result) => {
            if (result?.select) {
              if (result?.id === id) {
                if (stonelist.length) {
                  elem.classList.add("deactive");
                  let updatestone = stonelist.filter(
                    (item) => item !== result?.id
                  );
                  stone = updatestone;
                } else {
                  elem.classList.add("active");
                  stone.push(result?.id);
                }
              }
            }
          });
        } else {
          resultlist?.Stone.forEach((result) => {
            if (result?.id === id) {
              elem.classList.add("active");
              stone.push(result?.id);
            }
            // else if (result?.id !== id) {
            //   if (result?.select) {
            //     stone.push(result?.id)
            //   }
            // }
          });
        }
        setStonelist(stone);
      }
      if (label === "size") {
        let size = [...sizelist];
        let elem = document.getElementById(id);
        if (elem.classList.contains("active")) {
          resultlist?.size.forEach((result) => {
            if (result?.select) {
              if (result?.id === id) {
                if (sizelist.length) {
                  elem.classList.add("deactive");
                  let updatesize = sizelist.filter(
                    (item) => item !== result?.id
                  );
                  size = updatesize;
                } else {
                  elem.classList.add("active");
                  size.push(result?.id);
                }
              }
            }
          });
        } else {
          resultlist?.size.forEach((result) => {
            if (result?.id === id) {
              elem.classList.add("active");
              size.push(result?.id);
            }
            // else if (result?.id !== id) {
            //   if (result?.select) {
            //     size.push(result?.id)
            //   }
            // }
          });
        }
        setSizelist(size);
      }
      if (label === "lcoation") {
        let elem = document.getElementById(id);
        if (elem.classList.contains("active")) {
          elem.classList.remove("active");
        } else {
          elem.classList.add("active");
        }
      }
    }
  };
  const getImage = async () => {
    try {
      const postdata =
        `{
                 ProductImages(product_id:"` +
        imageid +
        `") {
                  image
                  name
              }
           
      }`;
      let responce = await graphqlPost(postdata, "App/graphql");
      setImage(responce?.data?.ProductImages?.image);
    } catch (err) {
      console.log(err, "err");
    }
  };
  useEffect(() => {
    if (!state?.faroReturnKey || !state?.faroMotherSku) return;

    const motherSku = state.faroMotherSku;
    const selections = state.faroSelections || {};
    const metal = selections.metal ? [selections.metal] : [];
    const stone = selections.stone ? [selections.stone] : [];
    const size = selections.size ? [selections.size] : [];

    setSearchsku(motherSku);
    if (isCrown) {
      setMetalListCrown(metal);
      setStoneListCrown(stone);
      setSizeListCrown(size);
    } else {
      setMetallist(metal);
      setStonelist(stone);
      setSizelist(size);
    }
    callsearchdetails(motherSku, {
      metal,
      stone,
      size,
      forceCatalog: isCrown,
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [state?.faroReturnKey]);

  useEffect(() => {
    if (searchsku && !isCrown) {
      if (skipInventoryFilterEffectRef.current) {
        skipInventoryFilterEffectRef.current = false;
        return;
      }
      callsearchdetails(undefined, { forceCatalog: false });
    }
    // eslint-disable-next-line
  }, [metallist, stonelist, sizelist]);
  useEffect(() => {
    if (imageid) {
      getImage();
    }
    // eslint-disable-next-line
  }, [imageid]);
  useEffect(() => {
    return () => {
        if (searchDebounceRef.current) {
            clearTimeout(searchDebounceRef.current);
        }
    };
}, []);

  const crownClick = () => {
    const nextIsCrown = !isCrown;
    setCrown(nextIsCrown);
    if (!searchsku) {
      return;
    }
    if (nextIsCrown) {
      setMetalListCrown([]);
      setStoneListCrown([]);
      setSizeListCrown([]);
      callsearchdetails(undefined, {
        forceCatalog: true,
        metal: [],
        stone: [],
        size: [],
        syncCatalogSelectionFromApi: true,
      });
      setSelected(true);
      return;
    }
    setResultlist(inventoryList);
    setSelected(false);
    callsearchdetails(undefined, { forceCatalog: false });
  };
  const AddtoCart = async (productIds) => {
    const ids = (Array.isArray(productIds) ? productIds : [productIds]).filter(
      Boolean
    );
    if (!ids.length) {
      error(t("Please select an item to add to cart."));
      return;
    }
    const GetloadingID = loading();
    try {
      const postdata = {
        order_type: "pos_order",
        customer_id: customer?.id,
        sales_person_id: saleperson?.value,
        items: ids.map((product_id) => ({ product_id })),
      };
      const res = await _Api(
        postdata,
        `api/v1/POS/customOrder/addInventoryItemsToCart`
      );
      if (res?.code !== 200) {
        Updateloading(t, GetloadingID, res?.message || t("Something went wrong"), "error");
        return;
      }

      const added = Array.isArray(res?.data?.added) ? res.data.added : [];
      const failed = Array.isArray(res?.data?.failed) ? res.data.failed : [];
      const addedCount = Number(
        res?.data?.added_count ?? added.filter((entry) => entry?.ok).length
      );
      const failedCount = Number(
        res?.data?.failed_count ?? failed.filter((entry) => !entry?.ok).length
      );
      const responseMessage = res?.message || t("Successfully Add to Cart!!");

      if (failedCount > 0 && addedCount === 0) {
        const failureReason =
          failed.find((entry) => entry?.reason)?.reason || responseMessage;
        Updateloading(t, GetloadingID, failureReason, "error");
        return;
      }

      Updateloading(t, GetloadingID, responseMessage);
      setsearchproductstatus(true);
      if (!isCrown) navigate("/app/pos/posscreen");
      if (state?.parkid) {
        GetCartdetailpark();
      } else if (
        (state?.order_id && state?.order_edit && state?.order_type) ||
        by_customorder ||
        by_repair_order
      ) {
        GetCartdetailpark();
      } else {
        setShowcheckout("sell");
      }
    } catch (err) {
      console.log(err, "err");
      Updateloading(t, GetloadingID, t("Something went wrong"), "error");
    }
  };
  const addtocustomcart = async (product_id) => {
    // if (!customer?.id) {
    //   error(t("Customer is Requried!!"));
    //   return;
    // }
    // if (!saleperson?.value) {
    //   error(t("SalePerson is Requried!!"));
    //   return;
    // }
    try {
      const clearpostdata = {};
      let res = await _Api(clearpostdata, `api/v1/POS/customOrder/cartClear`);
      if (res?.code === 200) {
        localStorage.removeItem("showcheckout");
        const postdata = {
          parentproduct_id: product_id,
          product_type: isCrown === true ? "catalog" : "inventory",
          order_type: "custom_order",
          customer_id: customer?.id,
          sales_person_id: saleperson?.value,
          metal: metalListCrown,
          size: sizeListCrown,
          stone: stoneListCrown,
        };
        let res = await _Api(postdata, `api/v1/POS/home/addTocart`);
        if (res.success === true) {
          success(t(res?.message));
          navigate("/app/pos/custom/createYourOwnSetting", {
            state: { cartid: res?.data, filtertype: isCrown },
          });
        } else {
          error(t("This Product Already in cart!!"));
        }
      }
    } catch (err) {
      console.log(err, "err");
    }
  };
  const hasCatalogSelection =
    metalListCrown.length > 0 ||
    stoneListCrown.length > 0 ||
    sizeListCrown.length > 0 ||
    orderCatalogItems.length > 0;
  const isCatalogNonVariant = Boolean(isCrown && resultlist?.nonVariant);
  const isInventoryNonVariant = Boolean(!isCrown && resultlist?.nonVariant);
  return (
    <>
      <div className="main-body">
        <div className="main-body-row">
          <div className="main-body-row-left-col p-0 wishlist-area">
            <div className="catalog-area">
            <div className="com-data-area overflow-hidden">
              <div className="catalog-area-header-area detail-area-header">
                <div className="catalog-area-header-area-control-pos">
                  <div className="catalog-area-header-area-control-pos-left page-back-btn-inside">
                    <Link to="/app/pos/menu">
                      <img
                        className="page-back-btn-inside-img"
                        src={base_assets + "/images/icons/arrow-left.png"}
                        alt="back"
                      />
                    </Link>
                    <h1 className="heading">{t("Quick View")}</h1>
                  </div>
                  <div className="catalog-area-header-area-control-pos-right">
                    <div className="com-search-area">
                      <button className="com-search-area-left-img wishlist-scan-icon scan-img">
                        <img
                          src={base_assets + "images/pos/icons/scan-icon.png"}
                          alt=""
                        />
                      </button>
                      <input
                        type="text"
                        value={searchsku}
                        // onChange={(e) => {
                        //   getsearchproductlist(e.target.value);
                        //   setSearchsku(e.target.value);
                        // }}
                        onChange={(e) => {
                          const value = e.target.value;
                      
                          setSearchsku(value);
                      
                          if (searchDebounceRef.current) {
                              clearTimeout(searchDebounceRef.current);
                          }
                      
                          searchDebounceRef.current = setTimeout(() => {
                            getsearchproductlist(value);
                          }, 300);
                      }}
                        placeholder={t("Scan barcode, Search SKU")}
                        id="dropdownMenuButton1"
                        data-bs-toggle="dropdown"
                        autoComplete="off"
                      />
                      <ul
                        className="dropdown-menu custom-search-dropdown"
                        aria-labelledby="dropdownMenuButton1"
                      >
                        {searchlist?.length
                          ? searchlist.map((result, key) => {
                            return (
                              <li key={key}>
                                <Link
                                  className="dropdown-item pos-search-result-item"
                                  onClick={() => {
                                    setSearchsku(result?.SKU);
                                    setMetalListCrown([]);
                                    setStoneListCrown([]);
                                    setSizeListCrown([]);
                                    setMetallist([]);
                                    setStonelist([]);
                                    setSizelist([]);
                                    skipInventoryFilterEffectRef.current = true;
                                    callsearchdetails(result?.SKU, {
                                      forceCatalog: isCrown,
                                      metal: [],
                                      stone: [],
                                      size: [],
                                      syncCatalogSelectionFromApi: isCrown,
                                    });
                                  }}
                                >
                                  <div className="pos-search-result-thumb">
                                    {result?.main_image ? (
                                      <img
                                        src={result.main_image}
                                        alt=""
                                        onError={(e) => {
                                          e.target.onerror = null; // prevent infinite loop
                                          e.target.src = "https://gis247.s3.us-east-2.amazonaws.com/placeholder-blank.png";
                                        }}
                                      />
                                    ) : null}
                                  </div>
                                  <div className="pos-search-result-text">
                                    <div className="pos-search-result-name">
                                      {result?.name}
                                    </div>
                                    <div className="pos-search-result-meta">
                                      {result?.SKU}
                                    </div>
                                  </div>
                                </Link>
                              </li>
                            );
                          })
                          : ""}
                      </ul>
                      <img
                        className="com-search-area-img"
                        src={
                          base_assets + "images/pos/icons/magnifying-glass.png"
                        }
                        alt=""
                      />
                    </div>
                  </div>
                </div>
              </div>
              <div>
                <div className="quick-view-inner">
                  {placeholder ? (
                    <img
                      className="quickviewimg"
                      // src="https://ananta.gispos.local/assets/v2/images/quickviewplaceholder.png"
                      src={quickviewplaceholder}
                      alt="quickviewplaceholder"
                    />
                  ) : (
                    <>
                      <div className="quick-view-inner-left">
                        <ImageGallery
                          items={image ? image : []}
                          showPlayButton={false}
                          showFullscreenButton={false}
                          showNav={false}
                          infinite={true}
                          disableSwipe={false}
                          disableThumbnailSwipe={false}
                          style={{ height: "75%" }}
                        // additionalClass={`${
                        //   screenSize.width > 1000 ? "img-view-slider" : undefined
                        // }`}
                        // thumbnailPosition={screenSize.width > 1000 ? "left" : "bottom"}
                        />
                      </div>

                      <div className="quick-view-inner-right">
                        <>
                          <div className="quick-view-inner-right-body">
                            <div className="quick-view-inner-right-body-header">
                              <div className="quick-view-inner-right-body-header-left">
                                <span className="quick-view-inner-right-body-header-left-sku-heading-sub">
                                  {resultlist?.name ? resultlist?.name : "-"}
                                </span>

                                <h6 className="quick-view-inner-right-body-header-left-sku-heading">
                                  {resultlist?.SKU ? resultlist?.SKU : "-"}
                                </h6>
                              </div>
                              <div className="quick-view-inner-right-body-header-right">
                                <div style={{ display: "flex", justifyContent: "center", alignItems: "center", gap: "1vw" }}>
                                  {isCrown === false && traceabilityEnabled ? 
                                  <img
                                    src={tracebigimg}
                                    alt="traceimg"
                                    style={{ width: "2vw", height: "2vw" }}
                                     data-bs-toggle="modal"
                                     data-bs-target="#OrderTraceabilityModal"
                                  /> : ""}
                                  <button
                                    className={
                                      isCrown
                                        ? "catalog-area-header-area-control-left-btn warehouse"
                                        : "catalog-area-header-area-control-left-btn"
                                    }
                                    onClick={() => {
                                      crownClick();
                                    }}
                                  >
                                    <img
                                      src={
                                        isCrown === false
                                          ? catalogtogglebtn
                                          : base_assets +
                                          "images/pos/icons/crown-outline.png"
                                      }
                                      alt=""
                                    />
                                  </button>
                                </div>
                              </div>
                            </div>
                            <div className="quick-view-inner-right-body-option-area">
                              <h6 className="quick-view-inner-right-body-option-area-heading">
                                {t("Metal")}
                              </h6>
                              <div className="quick-view-inner-right-body-option-area-row">
                                {resultlist?.metal
                                  ? resultlist?.metal.map((result, key) => {
                                    return (
                                      <div
                                        key={"m" + key}
                                        className="quick-view-inner-right-body-option-area-row-single"
                                        onClick={() => {
                                          setStatus(true);
                                        }}
                                      >
                                        <input
                                          type="checkbox"
                                          id={result?.id}
                                          disabled={result?.select === 0 || isCatalogNonVariant || isInventoryNonVariant}
                                          checked={
                                            isCrown
                                              ? isCatalogCategorySelected(
                                                  result,
                                                  metalListCrown
                                                )
                                              : undefined
                                          }
                                          className={
                                            isCrown
                                              ? getCatalogFilterInputClass(
                                                  result,
                                                  metalListCrown,
                                                  isCatalogNonVariant
                                                )
                                              : getInventoryFilterInputClass(
                                                  result,
                                                  isInventoryNonVariant
                                                )
                                          }
                                          onChange={() =>
                                            update_filters(
                                              "metal",
                                              result?.id,
                                              result
                                            )
                                          }
                                        />
                                        <label
                                          className="quick-view-inner-right-body-option-area-row-single-label"
                                          htmlFor={result?.id}
                                        >
                                          {result?.name}
                                        </label>
                                      </div>
                                    );
                                  })
                                  : ""}
                              </div>
                            </div>
                            <div className="quick-view-inner-right-body-option-area">
                              <h6 className="quick-view-inner-right-body-option-area-heading">
                                {t("Stone")}
                              </h6>
                              <div className="quick-view-inner-right-body-option-area-row">
                                {resultlist?.Stone
                                  ? resultlist?.Stone.map((result, key) => {
                                    return (
                                      <div
                                        key={"st" + key}
                                        className="quick-view-inner-right-body-option-area-row-single"
                                      >
                                        <input
                                          type="checkbox"
                                          id={result?.id}
                                          disabled={result?.select === 0 || isCatalogNonVariant || isInventoryNonVariant}
                                          checked={
                                            isCrown
                                              ? isCatalogCategorySelected(
                                                  result,
                                                  stoneListCrown
                                                )
                                              : undefined
                                          }
                                          className={
                                            isCrown
                                              ? getCatalogFilterInputClass(
                                                  result,
                                                  stoneListCrown,
                                                  isCatalogNonVariant
                                                )
                                              : getInventoryFilterInputClass(
                                                  result,
                                                  isInventoryNonVariant
                                                )
                                          }
                                          onChange={() =>
                                            update_filters(
                                              "stone",
                                              result?.id,
                                              result
                                            )
                                          }
                                        />
                                        <label
                                          className="quick-view-inner-right-body-option-area-row-single-label"
                                          htmlFor={result?.id}
                                        >
                                          {result?.name}
                                        </label>
                                      </div>
                                    );
                                  })
                                  : ""}
                              </div>
                            </div>
                            <div className="quick-view-inner-right-body-option-area">
                              <h6 className="quick-view-inner-right-body-option-area-heading">
                                {t("Size")}
                              </h6>
                              <div className="quick-view-inner-right-body-option-area-row">
                                {resultlist?.size
                                  ? resultlist?.size.map((result, key) => {
                                    return (
                                      <div
                                        key={"s" + key}
                                        className="quick-view-inner-right-body-option-area-row-single"
                                      >
                                        <input
                                          type="checkbox"
                                          id={result?.id}
                                          disabled={result?.select === 0 || isCatalogNonVariant || isInventoryNonVariant}
                                          checked={
                                            isCrown
                                              ? isCatalogCategorySelected(
                                                  result,
                                                  sizeListCrown
                                                )
                                              : undefined
                                          }
                                          className={
                                            isCrown
                                              ? getCatalogFilterInputClass(
                                                  result,
                                                  sizeListCrown,
                                                  isCatalogNonVariant
                                                )
                                              : getInventoryFilterInputClass(
                                                  result,
                                                  isInventoryNonVariant
                                                )
                                          }
                                          onChange={() =>
                                            update_filters(
                                              "size",
                                              result?.id,
                                              result
                                            )
                                          }
                                        />
                                        <label
                                          className="quick-view-inner-right-body-option-area-row-single-label"
                                          htmlFor={result?.id}
                                        >
                                          {result?.name}
                                        </label>
                                      </div>
                                    );
                                  })
                                  : ""}
                              </div>
                            </div>
                            <div className="quick-view-inner-right-body-option-area-location">
                              {/* <h6 className="quick-view-inner-right-body-option-area-heading">
                                {t("Location")}
                              </h6> */}
                              <div
                                style={{
                                  maxWidth: "60%",
                                  marginBottom: "2%",
                                  justifyContent: "space-between",
                                }}
                                className="d-flex"
                              >
                                <img src={locquickview} alt="location" />
                                <span>({resultlist?.total_qty ?? 0})</span>
                              </div>
                              {/* <div className="quick-view-inner-right-body-option-area-row">
                                                                {resultlist?.lcoation
                                                                    ? resultlist?.lcoation.map((result, key) => {
                                                                        return (
                                                                            <div
                                                                                key={'l' + key}
                                                                                className="quick-view-inner-right-body-option-area-row-single"
                                                                                onClick={() => setPo_id(result?.po_id)}
                                                                            >
                                                                                <input
                                                                                    type="checkbox"
                                                                                    id={result?.id}
                                                                                    className={
                                                                                        result?.select === 0
                                                                                            ? 'disable-input'
                                                                                            : ''

                                                                                    }
                                                                                    onClick={() =>
                                                                                        update_filters('lcoation', result?.id)
                                                                                    }
                                                                                />
                                                                                <label
                                                                                    className="quick-view-inner-right-body-option-area-row-single-label"
                                                                                    htmlFor={result?.id}
                                                                                >
                                                                                    {result?.name} <span className='danger-text'> (
                                                                                        {result?.qty
                                                                                            ? result?.qty
                                                                                            : '0'}
                                                                                        )</span>
                                                                                </label>
                                                                            </div>
                                                                        )
                                                                    })
                                                                    : ''}
                                                            </div> */}
                              {!isCrown ? (
                                <div className="location-list">
                                  {resultlist?.lcoation?.map((loc, index) => (
                                    <label
                                      key={index}
                                      className={`location-item ${
                                        loc.qty === 0 ? "disabled" : ""
                                      }`}
                                    >
                                      <input
                                        type="radio"
                                        name="location"
                                        disabled={loc.qty === 0}
                                        onClick={() => {
                                          if (selected === loc.id) {
                                            setSelected(null);
                                            setCrosslocation(false);
                                            setCrossLocationId(null);
                                          } else {
                                            setSelected(loc.id);
                                            getsearchproductlistloc(loc.id);
                                            const isDifferent =
                                              loc.id !== parsedObject["loc"];
                                            setCrosslocation(isDifferent);
                                            setCrossLocationId(
                                              isDifferent ? loc.id : null
                                            );
                                          }
                                        }}
                                        checked={selected === loc.id}
                                        readOnly
                                        className="custom-radio"
                                      />
                                      <span className="custom-radio-display" />

                                      <img
                                        src={
                                          base_assets +
                                          "images/square-flags/" +
                                          loc?.currency?.toLowerCase() +
                                          ".png"
                                        }
                                        alt={loc.currency}
                                        className="flag"
                                      />

                                      <span className="location-name">
                                        {loc?.name}
                                      </span>
                                      <span className="location-qty">
                                        {loc.qty}
                                      </span>
                                    </label>
                                  ))}
                                </div>
                              ) : (
                                ""
                              )}
                            </div>
                          </div>
                          {!placeholder && selected && (
                            <div className="btn-res-order">
                              <button
                                type="button"
                                data-bs-toggle="modal"
                                data-bs-target="#orderModal"
                                onClick={() => setReserve(true)}
                                disabled={isCrown}
                                style={{
                                  flex: 1,
                                  border: !isCrown ? "1px solid #FFBA58" : "", // orange border
                                  backgroundColor: "white",
                                  color: !isCrown ? "#FFBA58" : "", // orange text
                                  padding: "10px",
                                  borderRadius: "8px",
                                  fontWeight: "bold",
                                  cursor: isCrown ? "not-allowed" : "pointer",
                                  display: "flex",
                                  alignItems: "center",
                                  justifyContent: "center",
                                }}
                              >
                                {t("RESERVE")}
                              </button>

                              {!isCrown ? (
                                <button
                                  type="button"
                                  data-bs-toggle="modal"
                                  data-bs-target="#orderModal"
                                  disabled={!selectLocationflag}
                                  style={{
                                    flex: 1,
                                    backgroundColor: !selectLocationflag
                                      ? "white"
                                      : "#FFBA58",
                                    color: !selectLocationflag ? "" : "white",
                                    padding: "10px",
                                    borderRadius: "8px",
                                    fontWeight: "bold",
                                    border: !selectLocationflag ? "" : "none",
                                    cursor: !selectLocationflag
                                      ? "not-allowed"
                                      : "pointer",
                                    display: "flex",
                                    alignItems: "center",
                                    justifyContent: "center",
                                    pointerEvents: !selectLocationflag
                                      ? "none"
                                      : "auto",
                                  }}
                                >
                                  {t("ADD TO CART")}
                                </button>
                              ) : (
                                <button
                                  type="button"
                                  data-bs-toggle="modal"
                                  data-bs-target="#orderModal"
                                  disabled={!hasCatalogSelection}
                                  style={{
                                    flex: 1,
                                    backgroundColor: !hasCatalogSelection
                                      ? "white"
                                      : "#f9a825",
                                    color: !hasCatalogSelection ? "" : "white",
                                    padding: "10px",
                                    borderRadius: "8px",
                                    fontWeight: "bold",
                                    border: !hasCatalogSelection ? "" : "none",
                                    display: "flex",
                                    alignItems: "center",
                                    justifyContent: "center",
                                  }}
                                >
                                  {t("ORDER")}
                                </button>
                              )}
                            </div>
                          )}
                        </>
                      </div>
                    </>
                  )}
                </div>
              </div>
            </div>
            <OrderModal
              id="orderModal"
              items={isCrown ? orderCatalogItems : orderItems}
              AddtoCart={AddtoCart}
              reserve={reserve}
              setReserve={setReserve}
              isCrown={isCrown}
              parentid={parentid}
              crosslocation={crosslocation}
              crossLocationId={crossLocationId}
            />
            <OrderTracebilityModal
            items={orderItems}
            />
            <Link
              to="/app/pos/catalog/smart-search"
              state={{
                fromQuickview: true,
                quickviewState: {
                  parkid: state?.parkid,
                  order_id: state?.order_id,
                  order_edit: state?.order_edit,
                  order_type: state?.order_type,
                },
              }}
              className="catalog-area__faro-search-quickview"
              aria-label={t("FARO Search")}
              aria-disabled={!isFaroActive}
              onClick={handleFaroClick}
              style={!isFaroActive ? { opacity: 0.4, cursor: "not-allowed" } : undefined}
              // title={t("FARO Search")}
            >
                            <div
          className="kycTooltip-area-up"
          style={{ width: "auto", height: "auto",marginTop:0 }}
        >
                <img src={faromainicon} alt="" aria-hidden />
                <span className="kycTooltip-area-up-text" style={{  minWidth:'32px',padding:'5px 5px',  bottom: 'calc(100% - -4px)'}}>faro</span>

              </div>
              {/* <img src={faromainicon} alt="" aria-hidden /> */}
            </Link>
            </div>
          </div>
          <div className="main-body-row-right-col">
            {showcheckout === "sell" ? (
              <CheckoutSell
                setShowcheckout={setShowcheckout}
                setUpdatedCart={setUpdatedCart}
                UpdatedCart={UpdatedCart}
                setShowpayment={setShowpayment}
                showpayment={showpayment}
                setdeletestatus={setdeletestatus}
                setsearchproductstatus={setsearchproductstatus}
                searchproductstatus={searchproductstatus}
                parkid={state?.parkid}
                order_id={state?.order_id}
                ordertype={"reserve"}
                order_edit={state?.order_edit}
                order_type={state?.order_type}
                inv_orderid={inv_orderid}
                inv_ordertype={inv_ordertype}
                by_repair_order={by_repair_order}
                by_customorder={by_customorder}
                uuid={uuid}
                setCartstockid={setCartstockid}
                stock_id={stockid}
              />
            ) : showcheckout === "payment" ? (
              <CheckoutPayment
                UpdatedCart={UpdatedCart}
                setShowcheckout={setShowcheckout}
                order_edit={state?.order_edit}
                order_id={inv_orderid ? inv_orderid : state?.order_id}
                order_type={
                  inv_ordertype === "custom_order"
                    ? "pos_order"
                    : inv_ordertype
                      ? inv_ordertype
                      : state?.order_type
                }
                by_custom_order={by_customorder}
                by_repair_order={by_repair_order}
              />
            ) : (
              <CheckoutBlank />
            )}
          </div>
        </div>
      </div>
    </>
  );
};
export default Quickview;
